module.exports = __webpack_public_path__ + "img/logowit.d9a0bd00.png";